import { UserProfile } from "../services/profile.service"

export function getDefaultVoiceActorName(role: string, profile: UserProfile | null): string | null {
  if (role === "admin") return "Admin"

  if (!profile) return null

  const name = [profile.firstname?.trim(), profile.lastname?.trim()].filter(Boolean).join(" ")
  return name || null
}
